import { Activity, Download, RefreshCcw, ShieldAlert } from "lucide-react";
import { Badge, Button, Card } from "../components/ui";
import { DataTable } from "../components/DataTable";
import { useTenantHealth } from "../data/supergestor-data";

export function SupportConsolePage() {
  const query = useTenantHealth();
  return (
    <div className="page-stack">
      <div className="notice">
        <ShieldAlert size={20} />
        <div>
          <strong>Acesso de suporte auditado</strong>
          <p>Impersonação somente leitura, prazo, justificativa e limite de ações.</p>
        </div>
      </div>
      <Card
        title="Saúde dos tenants"
        description="Integrações, filas, reconciliação e incidentes."
        action={
          <Button variant="secondary">
            <RefreshCcw size={16} /> Diagnosticar todos
          </Button>
        }
      >
        <DataTable
          rows={query.data ?? []}
          getKey={(row) => row.tenantId}
          columns={[
            { key: "tenant", header: "Tenant", render: (row) => row.slug },
            {
              key: "status",
              header: "Lifecycle",
              render: (row) => <Badge tone="info">{row.status}</Badge>,
            },
            {
              key: "integrations",
              header: "Integrações",
              render: (row) => (
                <Badge tone={row.failed ? "danger" : "success"}>
                  {row.healthy} saudáveis / {row.failed} falhas
                </Badge>
              ),
            },
            {
              key: "queues",
              header: "Filas",
              render: (row) => `${row.inbox} in · ${row.outbox} out · ${row.deadLetters} DLQ`,
            },
            {
              key: "reconciliation",
              header: "Divergências",
              render: (row) => (
                <Badge tone={row.reconciliation ? "warning" : "success"}>
                  {row.reconciliation}
                </Badge>
              ),
            },
            {
              key: "incidents",
              header: "Críticos",
              render: (row) => (
                <Badge tone={row.criticalIncidents ? "danger" : "success"}>
                  {row.criticalIncidents}
                </Badge>
              ),
            },
            {
              key: "bundle",
              header: "",
              render: () => (
                <Button variant="ghost">
                  <Download size={15} /> Diagnóstico
                </Button>
              ),
            },
          ]}
        />
      </Card>
      <Card title="Runbooks">
        <div className="task-list">
          <div className="task-item">
            <Activity size={18} />
            <div>
              <strong>Paglog indisponível</strong>
              <span>Kill switch, preservação de comandos e reconciliação.</span>
            </div>
          </div>
          <div className="task-item">
            <Activity size={18} />
            <div>
              <strong>Pagamento sem baixa</strong>
              <span>Consulta externa, reprocessamento e auditoria.</span>
            </div>
          </div>
        </div>
      </Card>
    </div>
  );
}
